export function clearApiCache() {
	if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
		console.log('clear api cache:1');
		navigator.serviceWorker.controller.postMessage({ action: 'clear-api-cache' });
	}
}
